export default function WhatIsInfluencerProfilePage() {
  return (
    <section className="section-padding bg-light">
      <div className="container px-4 sm:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="mb-8">
            <h1 className="text-4xl font-bold text-dark mb-4">What is an influencer profile?</h1>
            <p className="text-xl text-gray-600 font-dm-sans">
              An influencer profile is a modern replacement for traditional media kits that showcases your platforms, audience, and brand collaborations in one shareable link.
            </p>
          </div>
          <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg prose prose-lg max-w-none">
            <p className="text-gray-600 mb-4">
              Creators use InfluenceHub to build a professional creator profile that acts like a resume for influencers, consolidating your content, platform statistics, audience demographics, and past brand collaborations in one professional media kit.
            </p>
            <p className="text-gray-600 mb-6">
              Share your profile link with brands via email, DMs, or your social bio. One link to share with any brand.
            </p>
            <a href="/signup" className="inline-flex items-center justify-center rounded-xl px-6 py-3 text-base font-semibold text-white bg-primary hover:bg-primary/90 transition font-dm-sans">
              Create your profile →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
